var table = $('#dataTable');
var tableDiv = $('#tableDiv');
var showTable = $('#showTable');

$(document).ready(() => {
    showTable.on('click', initializeDataTable);
});

function showDataTable() {
    tableDiv.slideDown(() => {
        table.DataTable().columns.adjust();
        showTable.off();
        showTable.on('click', hideDataTable);
        showTable.text('Hide Output DataTable');
    });
}

function hideDataTable() {
    tableDiv.slideUp(() => {
        showTable.off();
        showTable.on('click', showDataTable);
        showTable.text('Show Output DataTable');
    });
}

function initializeDataTable() {
    table.DataTable({
        "scrollX" : true,
        "dom"     :
            "<'ui grid'" +
            "<'row no-gutters justify-content-between align-items-center mb-3'" +
            "<''l>" +
            "<''B>" +
            "<''f>" +
            ">" +
            "<'row dt-table'" +
            "<'col-md-12'tr>" +
            ">" +
            "<'row no-gutters justify-content-between align-items-center mt-3'" +
            "<''i>" +
            "<''p>" +
            ">" +
            ">",
        "buttons" : [
            'copyHtml5',
            {
                extend    : 'excelHtml5',
                text      : 'Excel',
                customize : function (xlsx) {
                    addRareSourceExportHeaderFooterXlsx(xlsx);
                }
            },
            {
                extend    : 'csvHtml5',
                text      : 'CSV',
                customize : function (csv) {
                    return addRareSourceExportAttribution(csv);
                }
            },
            'pdfHtml5'
        ]
    });

    showDataTable();
}
